export default "__VITE_ASSET__CNnjdIyR__"